(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["alloi-skip-ahead"] && !Shopify.designMode) return;
  try {
    class AlloiSkipAhead extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.cfg = {
        format: this.dataset.format || 'Skip to {section}',
        topLabel: this.dataset.topLabel || 'Back to top',
        end: this.dataset.end || 'top',
        idle: parseInt(this.dataset.idle, 10) || 700,
        autoHide: this.dataset.autohide === 'true',
        autoHideDelay: parseInt(this.dataset.autohideDelay, 10) || 3500,
        mobileOnly: this.dataset.mobileOnly === 'true',
        offset: parseInt(this.dataset.offset, 10) || 80,
        auto: this.dataset.auto !== 'false',
      };

      this.control = this.querySelector('.alloi-skip');
      this.labelEl = this.querySelector('.alloi-skip__label');
      this.arrowSvg = this.querySelector('.alloi-skip__arrow svg');
      if (!this.control) return;

      this.parseStops();
      this.relocate();

      this.control.addEventListener('click', () => this.go());
      this._onScroll = () => this.onScroll();
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', () => { this.parseStops(); }, { passive: true });

      // First evaluation shortly after load (covers landing already scrolled).
      this._idleTimer = setTimeout(() => { this.update(); this.maybeShow(); }, this.cfg.idle);
    }

    parseStops() {
      const raw = this.cfg.auto ? this.autoStops() : this.manualStops();
      this.allStops = raw.sort((a, b) =>
        a.el.compareDocumentPosition(b.el) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1
      );
    }

    manualStops() {
      return (this.dataset.sections || '')
        .split('\n')
        .map((l) => l.trim())
        .filter(Boolean)
        .map((line) => {
          const parts = line.split('|');
          const label = (parts[0] || '').trim();
          const sel = (parts[1] || '').trim();
          let el = null;
          try { el = sel ? document.querySelector(sel) : null; } catch (e) { el = null; }
          return el ? { label, el } : null;
        })
        .filter(Boolean);
    }

    // Build stops from the page's own sections: every top-level Shopify section
    // below the product block that has a heading. Works on any product template
    // without a hand-maintained selector list.
    autoStops() {
      const main = this.closest('.shopify-section');
      const out = [];
      document.querySelectorAll('.shopify-section').forEach((sec) => {
        if (sec === main) return;
        if (/header|footer|announcement/i.test(sec.className || '')) return;
        if (sec.closest('.shopify-section-group-header-group, .shopify-section-group-footer-group')) return;
        const h = sec.querySelector('h1, h2, h3');
        if (!h) return;
        let label = (h.textContent || '').replace(/\s+/g, ' ').trim();
        if (!label) return;
        // Keep pill labels short: prefer the part before a colon, then cap
        // length at a word boundary so we never cut mid-word.
        label = label.split(':')[0].trim();
        if (label.length > 26) label = label.slice(0, 26).replace(/\s+\S*$/, '').replace(/[.,;\s]+$/, '') + '…';
        out.push({ label, el: sec });
      });
      return out;
    }

    isVisible(el) {
      if (!el || !el.isConnected) return false;
      const cs = getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden' || cs.visibility === 'collapse') return false;
      // offsetParent is null when the element or an ancestor is display:none.
      if (el.offsetParent === null && cs.position !== 'fixed') return false;
      const r = el.getBoundingClientRect();
      if (r.width === 0 && r.height === 0) return false;
      return true;
    }

    visibleStops() {
      return this.allStops.filter((s) => this.isVisible(s.el));
    }

    relocate() {
      this.bar = document.querySelector('.sticky-add-to-cart__bar');
      if (this.bar) {
        if (getComputedStyle(this.bar).position === 'static') this.bar.style.position = 'fixed';
        this.bar.appendChild(this.control);
      }
    }

    update() {
      // Re-resolve every time so late-injected (e.g. lazy reviews) and
      // currently-hidden sections are accounted for, and skip anything
      // that isn't visible right now.
      this.parseStops();
      const stops = this.visibleStops();
      if (!stops.length) { this.control.hidden = true; return; }
      // "Skip ahead" = the first visible stop that still starts below the
      // header line, i.e. ahead of where we're currently reading.
      const ahead = this.cfg.offset + 4;
      const nextStop = stops.find((s) => s.el.getBoundingClientRect().top > ahead) || null;

      if (nextStop) {
        this.mode = 'section';
        this.target = nextStop.el;
        this.labelEl.textContent = this.cfg.format.replace('{section}', nextStop.label);
        this.setArrowUp(false);
        this.control.hidden = false;
      } else if (this.cfg.end === 'top') {
        this.mode = 'top';
        this.target = null;
        this.labelEl.textContent = this.cfg.topLabel;
        this.setArrowUp(true);
        this.control.hidden = false;
      } else {
        this.control.hidden = true;
      }
    }

    setArrowUp(up) {
      if (this.arrowSvg) this.arrowSvg.style.transform = up ? 'rotate(180deg)' : '';
    }

    onScroll() {
      this.hide();
      clearTimeout(this._idleTimer);
      clearTimeout(this._autoHideTimer);
      this._idleTimer = setTimeout(() => { this.update(); this.maybeShow(); }, this.cfg.idle);
    }

    maybeShow() {
      if (this.cfg.mobileOnly && window.innerWidth > 749) return;
      if (!this.bar || this.bar.getAttribute('data-stuck') !== 'true') return;
      this.update();
      if (this.control.hidden) return;
      this.control.classList.add('is-shown');
      if (this.cfg.autoHide) {
        this._autoHideTimer = setTimeout(() => this.hide(), this.cfg.autoHideDelay);
      }
    }

    hide() {
      this.control.classList.remove('is-shown');
    }

    go() {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const behavior = reduce ? 'auto' : 'smooth';
      if (this.mode === 'top') {
        window.scrollTo({ top: 0, behavior });
      } else if (this.target) {
        const y = this.target.getBoundingClientRect().top + window.scrollY - this.cfg.offset;
        window.scrollTo({ top: y, behavior });
      }
      this.hide();
    }
  }

  if (!customElements.get('alloi-skip-ahead')) {
    customElements.define('alloi-skip-ahead', AlloiSkipAhead);
  }
  } catch(e) { console.error(e); }
})();

})();
